import React from 'react';
import { Theme } from '@material-ui/core';

import { InstallerIcon, ManufacturerIcon, OwnerIcon, VerifierIcon } from 'ui/icons';
import { UserRole } from 'context/user/userContext/UserContext.types';

export const getAccountTypes = (theme: Theme) => [
  {
    label: 'account_type.owner',
    icon: <OwnerIcon color="inherit" />,
    color: theme.palette.primary.main,
    role: UserRole.Owner,
  },
  {
    label: 'account_type.verifier',
    icon: <VerifierIcon color="inherit" />,
    color: theme.palette.secondary.main,
    role: UserRole.Verifier,
  },
  {
    label: 'account_type.installer',
    icon: <InstallerIcon color="inherit" />,
    color: theme.palette.yellow.main,
    role: UserRole.Installer,
  },
  {
    label: 'account_type.manufacturer',
    icon: <ManufacturerIcon color="inherit" />,
    color: theme.palette.red.main,
    role: UserRole.Manufacturer,
  },
];
